export default class Activity {
   constructor(bxItem) {
      if (!bxItem) return;
      
      this.id = bxItem.ID;
      this.createDateStart = new Date(bxItem.START_TIME);
      this.createDateEnd = new Date(bxItem.END_TIME);

      this.typeId = bxItem.TYPE_ID;
      switch(this.typeId) {
         case '1':
            this.type = 'activity.type.meeting';
            break;
         case '2':
            this.type = 'activity.type.call';
            break;
         case '4':
         case '6':
            this.type = 'activity.type.online';
            break;
      }

      this.responsibleId = bxItem.RESPONSIBLE_ID;
      this.responsible = null;

      this.contactId = null;
      this.leadId = null;
      this.dealId = null;
      this.contact = null;
      this.lead = null;

      switch (bxItem.OWNER_TYPE_ID) {
         case '1':
            this.leadId = bxItem.OWNER_ID;
            break;
         case '2':
            this.dealId = bxItem.OWNER_ID;
            break;
         case '3':
            this.contactId = bxItem.OWNER_ID;
            break;
      }

      this._subject = bxItem.SUBJECT;

      const div = document.createElement("div");
      div.innerHTML = bxItem.DESCRIPTION;
      this._description = div.textContent || div.innerText || '';

      this.smsp = '';
   }

   get createDate() {
      let view = '';
      if (!isNaN(this.createDateStart)) {
         view += this.createDateStart.toLocaleDateString('ru');
         // tmp?
         // if (!isNaN(this.createDateEnd)) {
         //    view += ` - ${this.createDateEnd.toLocaleString('ru')}`
         // }
      }

      return view
   }

   get resident() {
      return this.contact ? this.contact.crp : 'residentType.not-resident'
   }

   get birthDate() {
      if (this.contact && !isNaN(this.contact.birthDate)) {
         return this.contact.birthDate
      } else if (this.lead && !isNaN(this.lead.birthDate)) {
         return this.lead.birthDate
      }
      return ''
   }

   get regDate() {
      if (this.contact && !isNaN(this.contact.regDate)) {
         return this.contact.regDate || ''
      } else if (this.lead && !isNaN(this.lead.regDate)) {
         return this.lead.regDate || ''
      }
      return ''
   }

   get ogrn() {
      if (this.contact) {
         return this.contact.ogrn
      } else if (this.lead) {
         return this.lead.ogrn
      }
      return ''
   }

   get subject() {
      if (this._subject) {
         return this._subject
      } else if (this.lead) {
         return this.lead.subject
      }
      return ''
   }

   get phone() {
      if (this.contact?.phone) {
         return this.contact.phone
      } else if (this.lead?.phone) {
         return this.lead.phone
      }
      return ''
   }

   get email() {
      if (this.contact?.email) {
         return this.contact.email
      } else if (this.lead?.email) {
         return this.lead.email
      }
      return ''
   }

   get contactType() {
      if (this.contact) {
         return this.contact.type
      } else if (this.lead) {
         return this.lead.type
      }
      return ''
   }

   get description() {
      if (this.typeId === '6') return '';

      if (this._description) {
         return this._description
      } else if (this.lead) {
         return this.lead.description
      }

      return ''
   }

   get fio() {
      return this.responsible ? this.responsible.fio : ''
   }

   get name() {
      if (this.contact) {
         return this.contact.name
      } else if (this.lead) {
         return this.lead.name
      }
      return ''
   }

   get inn() {
      if (this.contact) {
         return this.contact.inn || ''
      }
      if (this.lead) {
         return this.lead.inn || ''
      }
      return ''
   }
}